function SeededRandom(seed = false) {
    const a = 16807; // multiplier
    const m = 2147483647; // 2**31 - 1
    let s;
	
	if ( seed === false ) {
		s = Math.floor(Math.random() * m);
	}

	this.setSeed = function(seed) {
		s = seed;
	}
	
    this.nextFloat = function() {
        s = (s * a) % m;
        return s / m;
    };

	this.nextInt = function() {
		return Math.floor(this.nextFloat() * 100);
	}

	this.nextIntRange = function(min, max) {
        return Math.floor(this.nextFloat() * (max - min + 1)) + min;
    }
}


function formatDate(date) {
	return date.toLocaleString('hu-HU', {
	  year: 'numeric',
	  month: '2-digit',
	  day: '2-digit',
	  hour: '2-digit',
	  minute: '2-digit',
	  hour12: false
	}).replace(',', ' -');
};

function formatRelativeTime(date) {
	const now = new Date();
	const diffInSeconds = Math.floor((now - date) / 1000);
	const rtf = new Intl.RelativeTimeFormat('hu', { numeric: 'auto' });

	if (diffInSeconds < 60) {
	  return rtf.format(-diffInSeconds, 'second');
	} else if (diffInSeconds < 3600) {
	  return rtf.format(-Math.floor(diffInSeconds / 60), 'minute');
	} else if (diffInSeconds < 86400) {
	  return rtf.format(-Math.floor(diffInSeconds / 3600), 'hour');
	} else {
	  return rtf.format(-Math.floor(diffInSeconds / 86400), 'day');
	}
};


export {SeededRandom, formatDate, formatRelativeTime};
